import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from "rxjs";
import { HostAliasResource } from "libraries/service/resources/host-alias/host-alias.resource";
import {IHost} from "../../hotel/models/hotel";

@Pipe({
    name: 'hostAlias'
})
export class HostAliasPipe implements PipeTransform {

    constructor(
        private readonly hostAliasResource: HostAliasResource,
    ) {
    }

    public transform(hostCode?: string | IHost): Observable<string> {
        const hostNameObs: Observable<string> = this.hostAliasResource.getAlias(hostCode as string);
        return hostNameObs;
    }
}
